import React, { useContext, useMemo } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { Section } from '../../../../../../components/ModalSidebar'
import RadioGroup from '../../../../../../components/RadioGroup'
import SingleInputSelect from '../../../../../../components/SingleInputSelect'
import { getM365CustomerOptions } from '../../../../../../../_augmentt/selectors/customers'
import { DEFAULT_SETTINGS_SETUP } from './constants'
import DefaultSettingsSetupContext from './DefaultSettingsSetupContext'

const SETUP_TYPE_MESSAGES = {
  [DEFAULT_SETTINGS_SETUP.GLOBAL]: 'DEFAULT_SETTINGS.GLOBALLY',
  [DEFAULT_SETTINGS_SETUP.SELECT_COMPANY]: 'DEFAULT_SETTINGS.SELECTED_COMPANIES',
}

const propTypes = {}

/**
 * Setup section for the Default Settings modals
 * Use this with useDefaultSettingsSetup to "auto" handle the setup for default settings modals
 * NOTE: this component expect that you are providing the result of useDefaultSettingsSetup through the DefaultSettingsSetupContext
 */
function DefaultSettingsSetupSection() {
  const {
    setupType,
    onSetupTypeChange,
    setupCompany,
    onSetupCompanyChange,
    isValidSetup,
    isSetupCompanyTouched,
    setIsSetupCompanyTouched,
  } = useContext(DefaultSettingsSetupContext)

  const intl = useIntl()

  const companyOptions = useSelector(getM365CustomerOptions)

  const setupOptions = useMemo(
    () =>
      Object.values(DEFAULT_SETTINGS_SETUP).map((type) => ({
        label: intl.formatMessage({ id: SETUP_TYPE_MESSAGES[type] }),
        value: type,
      })),
    [intl],
  )

  return (
    <Section title="TITLE.SETUP">
      <Row>
        <Col md={12}>
          <RadioGroup id="setupType" value={setupType} options={setupOptions} onChange={onSetupTypeChange} />
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          {setupType === DEFAULT_SETTINGS_SETUP.SELECT_COMPANY && (
            <SingleInputSelect
              id="setupCompany"
              values={setupCompany}
              options={companyOptions}
              onChange={onSetupCompanyChange}
              onBlur={() => setIsSetupCompanyTouched(true)}
              errors={
                !isValidSetup && isSetupCompanyTouched
                  ? [intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })]
                  : []
              }
            />
          )}
        </Col>
      </Row>
    </Section>
  )
}

DefaultSettingsSetupSection.propTypes = propTypes

export default DefaultSettingsSetupSection
